import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  itemType: {
    display: 'inline-block',
    textTransform: 'uppercase',
    padding: theme.spacing(0.5, 1),
    '& > h3': {
      fontSize: ['1rem', '!important']
    }
  },
  liveType: {
    backgroundColor: '#EB2E6B',
    color: 'white'
  },
  auctionType: {
    backgroundColor: '#23c6c8',
    color: 'white'
  },
  fixedType: {
    backgroundColor: '#1ab394',
    color: 'white'
  },
  openType: {
    backgroundColor: '#1ab394',
    color: 'white'
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/components/ItemsList/Item/ItemType/styles.js